import { Chip } from "@mui/material";
import { useState } from "react";

interface ChipListProps {
  data?: string[];
  max?: number;
}

const chipStyle = {
  margin: "4px 4px 0 0",
};

export const ChipList = ({ data = [], max = data.length }: ChipListProps) => {
  const [isListOpen, setIsListOpen] = useState(false);

  if (!data.length) return null;

  const visibleItems = isListOpen ? data : data.slice(0, max);
  const hiddenCount = data.length - max;

  return (
    <>
      {visibleItems.map((item) => (
        <Chip
          sx={chipStyle}
          label={item}
          key={item}
          size="small"
          color="info"
        />
      ))}

      {hiddenCount > 0 && (
        <Chip
          label={isListOpen ? "свернуть" : `еще ${hiddenCount}`}
          onClick={() => setIsListOpen((prev) => !prev)}
          sx={chipStyle}
          size="small"
        />
      )}
    </>
  );
};
